import React, { useContext, useEffect } from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'
import useTourOperators from 'hooks/TourV2/useTourOperators'
import { fillArray } from 'lib/array/arrayUtils'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import TourOperatorTile from 'components/Tours/TourOperatorTile'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/v2/OfferListEventsContext'
import { useInView } from 'react-intersection-observer'

const OperatorLogoContainer = styled(Clickable)`
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
  border-radius: ${props => props.theme.borderRadius.medium};
  border: 1px solid ${props => props.theme.palette.neutral.six};
  padding: ${rem(12)};
`

function TourPageOperatorsCarousel() {
  const { fetching, operators } = useTourOperators()

  const onEvent = useContext(OfferListEventsContext)
  const [inViewRef, inView] = useInView({ triggerOnce: true, threshold: 0.5 })

  useEffect(() => {
    if (inView && onEvent) {
      const params = { category: 'operators' }
      onEvent(OfferListEvents.impression, params)
    }
  }, [inView, onEvent])

  return <VerticalSpacer gap={20} ref={inViewRef}>
    <Group direction="vertical" gap={24}>
      <LayoutContainer>
        <Heading variant="heading3">Featured tour <i>operators</i></Heading>
      </LayoutContainer>
      <FullWidthCarousel gap={12} itemsPerArrow={6} snap="start">
        {fetching &&
          fillArray(6).map((_, index) => <OperatorLogoContainer key={index}>
            <LoadingBox style={{ width: rem(180), height: rem(80) }} />
          </OperatorLogoContainer>)
        }
        {!fetching && operators && operators.map(operator => <TourOperatorTile key={operator.code} operator={operator} />)}
      </FullWidthCarousel>
    </Group>
  </VerticalSpacer>
}

export default TourPageOperatorsCarousel
